/**
 * Auth0 `redirect_uri` / logout `returnTo` for this build.
 *
 * Packaged Tauri loads the UI from a custom origin (often `http://tauri.localhost` on Windows, or
 * `https://tauri.localhost` when `useHttpsScheme` is enabled on the window in tauri.conf.json).
 * That value must appear in Auth0 → Application → Allowed Callback URLs, Allowed Logout URLs, and
 * Allowed Web Origins alongside your web URLs (e.g. `http://localhost:1420`, `http://127.0.0.1:1420`,
 * production `https://…`).
 *
 * Set `VITE_AUTH0_REDIRECT_URI` only if you intentionally fix the URI (e.g. custom protocol flow).
 */
export function getAuth0RedirectUri(): string {
  const fromEnv = (import.meta.env.VITE_AUTH0_REDIRECT_URI as string | undefined)?.trim();
  if (fromEnv) return fromEnv;
  return window.location.origin;
}
